<template>
<div class="chapter">
<div class="inner_page">
<section epub:type="foreword" id="_idContainer000" role="doc-foreword">
<p class="pl-fl-header">“I’m going to bunk here so I can keep an eye on things...”</p>
<p class="pl-fl-roman">Lizzie was going to sleep in the stable? On the floor?</p>
<p class="pl-fl-roman">It felt wrong to leave her there, which was silly because Heath had spent many a night in the lambing barns. But this wasn’t him. It was Lizzie. And when she stuck a ridiculously small pillow behind her head, he wanted to snatch it, send her to bed and say he’d watch the horse.</p>
<p class="pl-fl-roman">She gazed up at him, looking so much like the girl she’d been twelve years before. But different, too.</p>
<p class="pl-fl-roman">“It’s my job, Heath.” She kept her voice quiet. Matter-of-fact. And quite professional. “People don’t inherit a quarter share of a ranch worth millions without putting in some time. I’ll see you tomorrow.”</p>
<p class="pl-fl-roman">She was right. He knew that.</p>
<p class="pl-fl-roman">But walking away from her—moving through the door into the cold spring night—was one of the toughest things he’d done in a long time.</p>
<p class="pl-fl-roman">He did it because it was the right thing to do. But he hated every minute of it.</p>
</section>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// Introduction.vue?34fc1688